export function getSaleInvoiceLabel(hasInvoice: boolean): string {
  return hasInvoice ? 'Con factura' : 'Sin factura';
}
